import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTime } from 'luxon';
import { ControlsModule, SegovSigepoFormsCheckBoxComponent } from 'segov-sigepo-public-api';
import { PesquisaBasicaJornalInputDto } from 'src/app/domain/DTOs/input/pesquisa-basica-jornal.input.dto';
import { minimoTresCaracteresValidator } from 'src/app/utils/validators/abstract-control-common.validator';
import { FormUtils } from 'src/app/utils/validators/form.utils';

@Component({
  selector: 'app-segov-sigepo-pesquisa-form',
  standalone: true,
  imports: [
    ControlsModule,
    SegovSigepoFormsCheckBoxComponent,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './segov-sigepo-pesquisa-form.component.html',
  styleUrl: './segov-sigepo-pesquisa-form.component.css'
})
export class SegovSigepoPesquisaFormComponent implements AfterViewInit {

  @Input() LimiteMaxData: DateTime = DateTime.local();
  @Input() navegarParaTelaPesquisa = false;
  @Output() dadosPesquisaFormOutput = new EventEmitter<PesquisaBasicaJornalInputDto>;

  public pesquisaBasicaForm: FormGroup;

  constructor(
    private readonly route: ActivatedRoute,
    private router: Router
  ){
    this.pesquisaBasicaForm = new FormGroup({
      texto: new FormControl('', [Validators.required, minimoTresCaracteresValidator]),
      periodoDataInicial: new FormControl('', Validators.required),
      periodoDataFinal: new FormControl('', Validators.required),
      diarioExecutivo: new FormControl(true),
      diarioMunicipiosMineiros: new FormControl(false),
      diarioTerceiros: new FormControl(false),
      diarioEdicaoExtra: new FormControl(false),
      diarioJudiciario: new FormControl(false),
      diarioLegislativo: new FormControl(false)
    })
  }

  ngAfterViewInit(): void {
    FormUtils.compareDates(
      this.pesquisaBasicaForm.controls['periodoDataInicial'] as FormControl<string | null>,
      this.pesquisaBasicaForm.controls['periodoDataFinal'] as FormControl<string | null>
    );

    this.route.queryParams.subscribe(
      params => {
        if (params['dadosPesquisa']) {
          const dadosFiltroPreenchidos = JSON.parse(params['dadosPesquisa']) as PesquisaBasicaJornalInputDto;
          this.pesquisaBasicaForm.setValue(
            {
              'texto': dadosFiltroPreenchidos.textoPesquisa,
              'periodoDataInicial': dadosFiltroPreenchidos.dataPublicacaoInicial,
              'periodoDataFinal': dadosFiltroPreenchidos.dataPublicacaoFinal,
              'diarioExecutivo': dadosFiltroPreenchidos.diarioExecutivo,
              'diarioMunicipiosMineiros': dadosFiltroPreenchidos.diarioMunicipios,
              'diarioTerceiros': dadosFiltroPreenchidos.diarioTerceiros,
              'diarioEdicaoExtra': dadosFiltroPreenchidos.edicaoExtra,
              'diarioJudiciario': dadosFiltroPreenchidos.diarioJudiciario ?? false,
              'diarioLegislativo': dadosFiltroPreenchidos.diarioLegislativo ?? false
            });
          this.dadosPesquisaFormOutput.emit(dadosFiltroPreenchidos);
        }
      }
    );
  }

  public validaForm(): boolean {
    const possuiCadernoSelecionado = [
      this.pesquisaBasicaForm.get('diarioExecutivo')?.value,
      this.pesquisaBasicaForm.get('diarioMunicipiosMineiros')?.value,
      this.pesquisaBasicaForm.get('diarioTerceiros')?.value,
      this.pesquisaBasicaForm.get('diarioEdicaoExtra')?.value,
      this.pesquisaBasicaForm.get('diarioJudiciario')?.value,
      this.pesquisaBasicaForm.get('diarioLegislativo')?.value
    ].some(Boolean);

    return this.pesquisaBasicaForm.valid && possuiCadernoSelecionado;
  }

  public mapeiaEnviaDados(): void {
    if (!this.validaForm()) {
      return;
    }

    const dadoMapeados = new PesquisaBasicaJornalInputDto(
      this.pesquisaBasicaForm.get('texto')?.value,
      this.pesquisaBasicaForm.get('periodoDataInicial')?.value,
      this.pesquisaBasicaForm.get('periodoDataFinal')?.value,
      this.pesquisaBasicaForm.get('diarioExecutivo')?.value,
      this.pesquisaBasicaForm.get('diarioMunicipiosMineiros')?.value,
      this.pesquisaBasicaForm.get('diarioTerceiros')?.value,
      this.pesquisaBasicaForm.get('diarioEdicaoExtra')?.value,
      this.pesquisaBasicaForm.get('diarioJudiciario')?.value,
      this.pesquisaBasicaForm.get('diarioLegislativo')?.value,
      1,
      20
    );

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { dadosPesquisa: JSON.stringify(dadoMapeados) },
      queryParamsHandling: '',
      replaceUrl: true
    });

    this.dadosPesquisaFormOutput.emit(dadoMapeados);
  }

  public limparFiltros() {
    this.pesquisaBasicaForm.reset();
    this.pesquisaBasicaForm.get('diarioExecutivo')?.setValue(true);
    this.pesquisaBasicaForm.get('diarioMunicipiosMineiros')?.setValue(false);
    this.pesquisaBasicaForm.get('diarioTerceiros')?.setValue(false);
    this.pesquisaBasicaForm.get('diarioEdicaoExtra')?.setValue(false);
    this.pesquisaBasicaForm.get('diarioJudiciario')?.setValue(false);
    this.pesquisaBasicaForm.get('diarioLegislativo')?.setValue(false);
  }
}
